import { isEqual } from "lodash";

import { HistoryState, HistoryStateAction, HistoryStateActionType } from "./types";

export const reducer = <T>(state: HistoryState<T>, action: HistoryStateAction<T>): HistoryState<T> => {
  const { current, past, future } = state;
  const { type } = action;

  switch (type) {
    /** ======== UPDATE ======== */
    case HistoryStateActionType.UPDATE: {
      const { payload } = action;

      // if identical to prior state, return prior state
      const isIdentical = isEqual(payload, current);
      if (isIdentical) return state;

      /**
       * Update current state
       * add prior state to past
       * set future to empty */
      return {
        current: payload,
        past: [...past, current],
        future: [],
      };
    }

    /** ======== UNDO ======== */
    case HistoryStateActionType.UNDO: {
      const lastPast = past[past.length - 1];
      // if no past, return state
      if (!lastPast) return state;

      /**
       * Update current state to last value on past
       * Update past state removing last value
       * add prior current state to start of future */
      return {
        current: lastPast,
        past: past.slice(0, past.length - 1),
        future: [current, ...future],
      };
    }

    /** ======== UPDATE ======== */
    case HistoryStateActionType.REDO: {
      // if no future, return state
      if (!future[0]) return state;

      /**
       * Update current state to first value on future
       * Update past state adding current to end
       * Remove first value from future */
      return {
        current: future[0],
        past: [...past, current],
        future: future.slice(1),
      };
    }

    /** ======== RESET ======== */
    case HistoryStateActionType.RESET: {
      const { payload } = action;

      /**
       * reset current state to new payload
       * clear past
       * clear future */
      return {
        current: payload,
        past: [],
        future: [],
      };
    }

    default:
      return state;
  }
};
